import { render } from "./PrizeDetail.vue?vue&type=template&id=2c1e7590&lang=html"
import script from "./PrizeDetail.vue?vue&type=script&lang=js"
export * from "./PrizeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__